import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
import { Props } from './type'

interface PropsIcon extends Props {
  color?: string
}

export const CloseIcon = (props: PropsIcon) => (
  <Svg viewBox='0 0 21 20' fill='none' pointerEvents='none' {...props}>
    <Path
      d='M16.6667 5.34169L15.4917 4.16669L10.8333 8.82502L6.175 4.16669L5 5.34169L9.65833 10L5 14.6584L6.175 15.8334L10.8333 11.175L15.4917 15.8334L16.6667 14.6584L12.0083 10L16.6667 5.34169Z'
      fill={props.color ?? 'white'}
    />
  </Svg>
)
